import { render } from "./StockListComponent.vue?vue&type=template&id=a0e765e6&scoped=true"
import script from "./StockListComponent.vue?vue&type=script&lang=js"
export * from "./StockListComponent.vue?vue&type=script&lang=js"

import "./StockListComponent.vue?vue&type=style&index=0&id=a0e765e6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0e765e6"],['__file',"resources/js/components/admin/stock/StockListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a0e765e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a0e765e6', __exports__)) {
    api.reload('a0e765e6', __exports__)
  }
  
  module.hot.accept("./StockListComponent.vue?vue&type=template&id=a0e765e6&scoped=true", () => {
    api.rerender('a0e765e6', render)
  })

}


export default __exports__